export const HEADER_HEIGHT = 65;

export const METADATA_HEIGHT = 80;

export const EMAIL_MAX_LEN = 255;

export const PASSWORD_MAX_LEN = 72;

export const LOGIN_REDIRECT_URL = '/';

export const PUBLIC_ENDPOINT = '/graphql/public';

export const REGISTER_ENDPOINT = '/graphql/public/register';

export const LOGIN_ENDPOINT = '/graphql/public/login';

export const FORCE_EXTERNAL =
  window.location.host === 'cloud.digitalocean.com' && !window.location.pathname.startsWith('/registration-next');

export const APOLLO_CLIENT_NAME = 'registration-next';

export const APOLLO_CLIENT_VERSION = '1.0';

export const NETWORK_ERROR_CODE = 403;

export const NETWORK_TOO_MANY_REQUESTS_CODE = 429;

export const CF_RAY_ID_REGEXP = /(Cloudflare Ray ID: (<strong>)?)([a-z|0-9]*)(<\/strong>)?/;

export const APP_PLATFORM_TEMPLATE_COOKIE = '_digitalocean_app_platform_url_after_activation';

export const REDIRECT_URL_PARAM = 'redirect_url';

export const ACTIVATION_REDIRECT_COOKIE = '_digitalocean_activation_redirect';

export const ACTIVATION_REDIRECT_PARAM = 'activation_redirect';

export const GITHUB_STUDENT_PACK_COOKIE = '_digitalocean_gh_student_pack';

export const PREFERRED_SIGN_IN_COOKIE = '_digitalocean_remember_me';

export const GITHUB_STUDENT_PACK = 'github-student-pack';

export const ONBOARDING_ORIGIN_PARAM = 'onboarding_origin';
export const REFCODE_PARAM = 'refcode';

export const CHURN_SURVEY_URL = 'https://digitalocean.getfeedback.com/r/jgkIoAt5';

export const FLASH_ERROR_COOKIE_NAME = '_digitalocean_flash_error';

export const REGISTER_SHOW_OPTIONS_STEP = 0;
export const REGISTER_SHOW_FORM_STEP = 1;

export const UI_MANAGED_CONTENT_ENDPOINT = 'https://ui-managed-content.nyc3.digitaloceanspaces.com';

export const REGISTRATION_VARIANTS_FILE_BASE_PATH = '/REGISTRATION_VARIANTS';
export const PREVIEW_REGISTRATION_VARIANTS_PARAM = 'previewRegistrationVariants';
export const LOGIN_VARIANTS_FILE_BASE_PATH = '/LOGIN_VARIANTS';

export const PREVIEW_LOGIN_VARIANTS_PARAM = 'previewLoginVariants';

export const CONTACT_SUPPORT_URL = 'https://www.digitalocean.com/company/contact/support';

export const GROW_3829_SIGNUP_SELLING_POINTS = 'signup-selling-points';
export const GROW_3829_SIGNUP_SELLING_POINTS_TREATMENT_A = 'treatment';
export const GROW_3829_SIGNUP_SELLING_POINTS_TREATMENT_B = 'variant-b-customer-quottes';

// grow-4028-test-requesting-work-email-during-signup
export const GROW_4028_TEST_REQ_WORK_EMAIL_DURING_SIGNUP = 'grow-4028-test-requesting-work-email-during-signup';
export const GROW_4028_TEST_REQ_WORK_EMAIL_DURING_SIGNUP_TREATMENT = 'treatment';
